export const SET_USER = 'SET_USER';
export const LOG_OUT = 'LOG_OUT';
